import './App.css';
import sides from "./Assets/logoelements/sides.svg";
import star from "./Assets/logoelements/star.svg";
import logo from "./Assets/logos/logo.svg";

function App() {
  return (
    <div className="App">
      <div className="logo-animation">
        <img src={sides} className="sides" alt="sides" />
        <img src={star} className="star" alt="star" />
      </div>
      <span className="name">Belcian</span>
      <img src={logo} className="logo" alt="logo" />
    </div>
  );
}

export default App;
